export const baseEnvironment = {
  apiUrls: {
    orderEntry: "/api", // Foresight.API.OrderEntry
    configServ: "/api", // Foresight.API.ConfigServ
    vendorManagement: "/api", // Foresight.API.VendorManagement
    clientManagement: "/api", // Foresight.API.ClientManagement
    elsaWorkflow: "http://dev-workflow.rocktop.com/api", // Foresight.ElsaWorkflow
    auth: "http://dev-auth.rocktop.com/api", // Authentication service
    loanManagement: "/api",
    orderWorkflow: "/api",
    userManagement: "/api",
  },
  // Retry config
  httpRetry: {
    maxRetryAttempts: -1, //0 =< disabled
    scalingDuration: 1000,
    excludedStatusCodes: [400, 401, 403, 404],
  },
  cache: {
    defaultTTL: 5 * 60 * 1000,
    maxSize: 100,
  },
};
